import { create, test, enforce } from 'vest';

export const inviteTeamMemberForm = create('InviteTeamMemberForm', (data) => {
    test('email', 'A valid email is required.', () => {
        enforce(data.email)
            .isEmail();
    });
});

export const detailsForm = create('DetailsForm', (data) => {
    test('name', 'Your organisation name is required.', () => {
        enforce(data.name)
            .isNotEmpty();
    });

    if (data.website) {
        test('website', 'Url does not look valid.', () => {
            enforce(data.website)
                .isURL();
        });
    }
});

export const socialProfilesForm = create('SocialProfilesForm', (data) => {
    if (data.facebook) {
        test('facebook', 'Must be a valid facebook url.', () => {
            enforce(data.facebook)
                .isURL();
            enforce('facebook.com')
                .inside(data.facebook);
        });
    }

    if (data.twitter) {
        test('twitter', 'Must be a valid Twitter url.', () => {
            enforce(data.twitter)
                .isURL();
            enforce('twitter.com')
                .inside(data.twitter);
        });
    }

    if (data.instagram) {
        test('instagram', 'Must be a valid Instagram url.', () => {
            enforce(data.instagram)
                .isURL();
            enforce('instagram.com')
                .inside(data.instagram);
        });
    }
});
